module.exports = __webpack_public_path__ + "img/Group 1572.ed97e5ec.svg";